import { useEffect } from "react";
import { DtoPublicTest } from "@/types/dto-types";
import { useTranslation } from "react-i18next";

export function useTestLanguage(publicTest: DtoPublicTest) {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (publicTest) {
      i18n.changeLanguage(publicTest.languageId);
    }
  }, [publicTest, i18n]);
}
